import type { ComparisonConfig } from './ComparisonPage';


const INNROAD_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-innroad',
  competitorName: 'innRoad',
  heroTitle: 'HotelStack.io vs innRoad',
  heroSubtitle: 'innRoad est un PMS cloud am\u00e9ricain pour les h\u00f4tels ind\u00e9pendants avec un ensemble de fonctionnalit\u00e9s basique. HotelStack.io offre 36 modules incluant gestion avanc\u00e9e des revenus, restauration/POS, support multi-\u00e9tablissements et conformit\u00e9 mondiale \u2014 \u00e0 un prix comparable.',
  overviewComparison: [
    { label: 'Modules totaux', hotelstack: '36 modules int\u00e9gr\u00e9s', competitor: '8+ fonctionnalit\u00e9s de base' },
    { label: 'Tarification', hotelstack: '\u00c0 partir de 49 $/mois', competitor: '\u00c0 partir de 100 $+/mois' },
    { label: 'Multi-\u00e9tablissements', hotelstack: 'Gestion de cha\u00eene compl\u00e8te', competitor: 'Non pris en charge' },
    { label: 'Restauration / POS', hotelstack: 'Int\u00e9gr\u00e9', competitor: 'Non disponible' },
    { label: 'Port\u00e9e mondiale', hotelstack: 'Plus de 40 pays', competitor: 'Centr\u00e9 \u00c9tats-Unis' },
    { label: 'Gestion des revenus', hotelstack: 'Avanc\u00e9e (int\u00e9gr\u00e9e)', competitor: 'Outils tarifaires basiques' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'PMS cloud', hotelstack: true, competitor: true },
        { name: 'Tableau visuel des chambres', hotelstack: true, competitor: true },
        { name: 'Gestion des r\u00e9servations', hotelstack: true, competitor: true },
        { name: 'Assistant d\'audit de nuit', hotelstack: true, competitor: true },
        { name: 'Gestion du folio client', hotelstack: true, competitor: true },
        { name: 'Portail d\'enregistrement en ligne', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Distribution et r\u00e9servation',
      features: [
        { name: 'Gestionnaire de canaux (100+ OTA)', hotelstack: true, competitor: 'OTA limit\u00e9s' },
        { name: 'Connectivit\u00e9 GDS', hotelstack: true, competitor: true },
        { name: 'Moteur de r\u00e9servation sans commission', hotelstack: true, competitor: true },
        { name: 'R\u00e9servations de groupe', hotelstack: true, competitor: 'Basique' },
        { name: 'Gestion des tarifs entreprise', hotelstack: true, competitor: 'Limit\u00e9' },
      ],
    },
    {
      category: 'Gestion des revenus',
      features: [
        { name: 'R\u00e8gles de tarification dynamique', hotelstack: true, competitor: 'Basique' },
        { name: 'Simulateur de revenus hypoth\u00e9tique', hotelstack: true, competitor: false },
        { name: 'Surveillance des tarifs concurrents', hotelstack: true, competitor: false },
        { name: 'Pr\u00e9vision de la demande', hotelstack: true, competitor: false },
        { name: 'Analyses RevPAR', hotelstack: true, competitor: 'Basique' },
      ],
    },
    {
      category: 'Op\u00e9rations et restauration',
      features: [
        { name: 'Terminal point de vente', hotelstack: true, competitor: false },
        { name: 'Module service en chambre', hotelstack: true, competitor: false },
        { name: 'Gestion du m\u00e9nage', hotelstack: true, competitor: 'Basique' },
        { name: 'Ordres de travail de maintenance', hotelstack: true, competitor: false },
        { name: 'Planification du personnel', hotelstack: true, competitor: false },
        { name: 'Syst\u00e8me d\'affichage cuisine', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Rapports et conformit\u00e9',
      features: [
        { name: 'Rapport flash', hotelstack: true, competitor: true },
        { name: 'Compte de r\u00e9sultat', hotelstack: true, competitor: false },
        { name: 'Rapport de rythme', hotelstack: true, competitor: false },
        { name: 'Facturation multidevise', hotelstack: true, competitor: false },
        { name: 'Conformit\u00e9 fiscale r\u00e9gionale', hotelstack: true, competitor: '\u00c9tats-Unis uniquement' },
        { name: 'G\u00e9n\u00e9rateur de rapports personnalis\u00e9s', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'R\u00e9silience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arri\u00e8re-plan \u00e0 la reconnexion', hotelstack: true, competitor: false },
        { name: 'R\u00e9conciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'R\u00e9ception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'R\u00e9servation de groupe avec listes de chambres', hotelstack: true, competitor: 'Basique' },
        { name: 'Rapports de cr\u00e9ances et de production', hotelstack: true, competitor: false },
        { name: 'R\u00e9servations de restaurant', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: false },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Cong\u00e9s et pr\u00e9sences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$100+',
    hotelstackNote: 'Les 36 modules inclus. Support multidevise mondial. Tarification r\u00e9gionale en EUR, GBP, AED, INR, THB. Int\u00e9gration et migration gratuites.',
    competitorNote: 'Tarification sur devis \u00e0 partir de 100 $+/mois. Centr\u00e9 \u00c9tats-Unis avec fonctionnalit\u00e9s internationales limit\u00e9es. Ensemble basique sans restauration, multi-\u00e9tablissements ni analyses avanc\u00e9es.',
  },
  advantages: [
    'Quatre fois plus de modules (36 contre 8+) \u00e0 environ la moiti\u00e9 du prix de d\u00e9part',
    'Gestion compl\u00e8te de cha\u00eene multi-\u00e9tablissements \u2014 innRoad ne g\u00e8re que les \u00e9tablissements uniques',
    'Module complet de restauration avec POS, service en chambre, affichage cuisine et gestion des menus',
    'Gestion avanc\u00e9e des revenus avec tarification dynamique, pr\u00e9vision et simulateurs',
    'Port\u00e9e mondiale dans plus de 40 pays contre la focalisation am\u00e9ricaine d\'innRoad',
    'Facturation multidevise et conformit\u00e9 fiscale r\u00e9gionale pour les \u00e9tablissements internationaux',
    'Programme de fid\u00e9lit\u00e9, CRM client et communications automatis\u00e9es inclus',
    'Int\u00e9gration et migration de donn\u00e9es gratuites avec support d\u00e9di\u00e9 24h/24 7j/7',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'innRoad est un PMS cloud simple pour les h\u00f4tels ind\u00e9pendants am\u00e9ricains n\u00e9cessitant une gestion basique des r\u00e9servations et de la r\u00e9ception. HotelStack.io offre une plateforme beaucoup plus compl\u00e8te avec quatre fois plus de modules, le support multi-\u00e9tablissements, la restauration/POS, des outils de revenus avanc\u00e9s et une port\u00e9e mondiale \u2014 le tout \u00e0 un prix inf\u00e9rieur. Pour tout h\u00f4tel pr\u00e9voyant de d\u00e9passer les besoins PMS basiques, HotelStack.io est le choix \u00e9vident.',
    bestFor: [
      'H\u00f4tels ind\u00e9pendants souhaitant passer d\'un PMS basique \u00e0 une plateforme compl\u00e8te',
      '\u00c9tablissements n\u00e9cessitant restauration, POS et outils op\u00e9rationnels qu\'innRoad ne propose pas',
      'H\u00f4tels s\'\u00e9tendant \u00e0 l\'international n\u00e9cessitant multidevise et conformit\u00e9',
      '\u00c9tablissements souhaitant la gestion multi-\u00e9tablissements pour une croissance future',
      'H\u00f4tels recherchant une gestion avanc\u00e9e des revenus au-del\u00e0 de la tarification basique',
    ],
  },
  faqItems: [
    { question: 'Puis-je migrer d\'innRoad vers HotelStack.io ?', answer: 'Oui. Notre \u00e9quipe de migration g\u00e8re le transfert complet des donn\u00e9es depuis innRoad, y compris les profils clients, l\'historique des r\u00e9servations, les plans tarifaires et les configurations de chambres. La migration est gratuite et g\u00e9n\u00e9ralement termin\u00e9e en 48 heures sans interruption.' },
    { question: 'HotelStack.io prend-il en charge les h\u00f4tels ind\u00e9pendants am\u00e9ricains comme innRoad ?', answer: 'Absolument. HotelStack.io prend en charge les h\u00f4tels ind\u00e9pendants aux \u00c9tats-Unis et dans plus de 40 autres pays. Les h\u00f4tels am\u00e9ricains obtiennent les 36 modules, y compris des fonctionnalit\u00e9s qu\'innRoad ne propose pas comme la restauration/POS, la gestion des revenus et le multi-\u00e9tablissements \u2014 \u00e0 partir de 49 $/mois.' },
    { question: 'Comment HotelStack.io se compare-t-il \u00e0 innRoad pour la connectivit\u00e9 GDS ?', answer: 'Les deux plateformes offrent la connectivit\u00e9 GDS via Amadeus et Sabre. HotelStack.io se connecte en plus \u00e0 100+ OTA mondiaux, offre l\'int\u00e9gration m\u00e9tarecherche et inclut un moteur de r\u00e9servation sans commission (BookMyRoom.io) \u2014 le tout inclus dans le prix de base.' },
    { question: 'HotelStack.io peut-il g\u00e9rer plusieurs \u00e9tablissements contrairement \u00e0 innRoad ?', answer: 'Oui. HotelStack.io inclut la gestion compl\u00e8te de cha\u00eene avec tableau de bord centralis\u00e9, analyses inter-\u00e9tablissements, distribution tarifaire partag\u00e9e, application des standards de marque et rapports consolid\u00e9s. innRoad est con\u00e7u pour les op\u00e9rations mono-\u00e9tablissement uniquement.' },
  ],
};

const WEBREZPRO_FR: ComparisonConfig = {
  slug: 'hotelstack-vs-webrezpro',
  competitorName: 'WebRezPro',
  heroTitle: 'HotelStack.io vs WebRezPro',
  heroSubtitle: 'WebRezPro est un PMS cloud canadien ax\u00e9 sur la comptabilit\u00e9 ciblant les petits et moyens h\u00f4tels. HotelStack.io offre une plateforme moderne et riche en fonctionnalit\u00e9s avec 36 modules, une interface entreprise, des outils de revenus avanc\u00e9s et la restauration/POS compl\u00e8te \u2014 con\u00e7u pour la prochaine g\u00e9n\u00e9ration h\u00f4teli\u00e8re.',
  overviewComparison: [
    { label: 'Modules totaux', hotelstack: '36 modules int\u00e9gr\u00e9s', competitor: '10+ fonctionnalit\u00e9s de base' },
    { label: 'Tarification', hotelstack: '\u00c0 partir de 49 $/mois', competitor: '\u00c0 partir de 75 $+/mois' },
    { label: 'Qualit\u00e9 UI/UX', hotelstack: 'Design luxe sombre moderne', competitor: 'Fonctionnel / Dat\u00e9' },
    { label: 'Restauration / POS', hotelstack: 'Int\u00e9gr\u00e9', competitor: 'Non disponible' },
    { label: 'Gestion des revenus', hotelstack: 'Avanc\u00e9e (int\u00e9gr\u00e9e)', competitor: 'Outils tarifaires basiques' },
    { label: 'Multi-\u00e9tablissements', hotelstack: 'Gestion de cha\u00eene compl\u00e8te', competitor: 'Limit\u00e9' },
  ],
  featureTable: [
    {
      category: 'PMS principal',
      features: [
        { name: 'PMS cloud', hotelstack: true, competitor: true },
        { name: 'Tableau visuel des chambres', hotelstack: true, competitor: true },
        { name: 'Gestion des r\u00e9servations', hotelstack: true, competitor: true },
        { name: 'Assistant d\'audit de nuit', hotelstack: true, competitor: true },
        { name: 'Gestion du folio client', hotelstack: true, competitor: true },
        { name: 'Portail d\'enregistrement en ligne', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Comptabilit\u00e9 et finances',
      features: [
        { name: 'Comptabilit\u00e9 int\u00e9gr\u00e9e', hotelstack: true, competitor: true },
        { name: 'Compte de r\u00e9sultat', hotelstack: true, competitor: true },
        { name: 'Comptes clients', hotelstack: true, competitor: true },
        { name: 'Facturation multidevise', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Conformit\u00e9 fiscale r\u00e9gionale', hotelstack: true, competitor: 'Centr\u00e9 CAD/USD' },
        { name: 'Mod\u00e8les de factures personnalis\u00e9s', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Revenus et distribution',
      features: [
        { name: 'Gestionnaire de canaux (100+ OTA)', hotelstack: true, competitor: 'Moins d\'OTA' },
        { name: 'R\u00e8gles de tarification dynamique', hotelstack: true, competitor: 'Basique' },
        { name: 'Simulateur de revenus hypoth\u00e9tique', hotelstack: true, competitor: false },
        { name: 'Surveillance des tarifs concurrents', hotelstack: true, competitor: false },
        { name: 'Pr\u00e9vision de la demande', hotelstack: true, competitor: false },
        { name: 'Moteur de r\u00e9servation sans commission', hotelstack: true, competitor: true },
      ],
    },
    {
      category: 'Restauration et op\u00e9rations',
      features: [
        { name: 'Terminal point de vente', hotelstack: true, competitor: false },
        { name: 'Module service en chambre', hotelstack: true, competitor: false },
        { name: 'Syst\u00e8me d\'affichage cuisine', hotelstack: true, competitor: false },
        { name: 'Gestion du m\u00e9nage', hotelstack: true, competitor: true },
        { name: 'Ordres de travail de maintenance', hotelstack: true, competitor: false },
        { name: 'Planification du personnel', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Clients et entreprise',
      features: [
        { name: 'Profils clients 360 degr\u00e9s', hotelstack: true, competitor: 'Basique' },
        { name: 'Gestion du programme de fid\u00e9lit\u00e9', hotelstack: true, competitor: false },
        { name: 'Automatisation de la communication client', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Tableau de bord de la cha\u00eene', hotelstack: true, competitor: 'Limit\u00e9' },
        { name: 'Analyses inter-\u00e9tablissements', hotelstack: true, competitor: false },
        { name: 'Application des standards de marque', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Résilience et hors ligne',
      features: [
        { name: 'PWA fonctionnant hors ligne', hotelstack: true, competitor: false },
        { name: 'File d\'attente des modifications hors ligne', hotelstack: true, competitor: false },
        { name: 'Synchronisation en arrière-plan à la reconnexion', hotelstack: true, competitor: false },
        { name: 'Réconciliation tenant compte des conflits', hotelstack: true, competitor: false },
        { name: 'Réception installable', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Ventes entreprises et groupes',
      features: [
        { name: 'Gestion des tarifs entreprises', hotelstack: true, competitor: false },
        { name: 'Réservation de groupe avec listes de chambres', hotelstack: true, competitor: false },
        { name: 'Rapports de créances et de production', hotelstack: true, competitor: false },
        { name: 'Réservations de restaurant', hotelstack: true, competitor: false },
      ],
    },
    {
      category: 'Personnel et RH',
      features: [
        { name: 'Annuaire du personnel et planification', hotelstack: true, competitor: false },
        { name: 'Traitement de la paie', hotelstack: true, competitor: false },
        { name: 'Congés et présences', hotelstack: true, competitor: false },
        { name: 'Analyses de performance', hotelstack: true, competitor: false },
      ],
    },
  ],
  pricingComparison: {
    hotelstackStarting: '$49',
    competitorStarting: '$75+',
    hotelstackNote: 'Les 36 modules inclus. Interface moderne de qualit\u00e9 entreprise. Tarification r\u00e9gionale en EUR, GBP, AED, INR, THB. Int\u00e9gration et migration gratuites.',
    competitorNote: 'Tarification par chambre \u00e0 partir de 75 $+/mois CAD. Interface fonctionnelle mais dat\u00e9e. Restauration limit\u00e9e, multi-\u00e9tablissements limit\u00e9, support principalement nord-am\u00e9ricain.',
  },
  advantages: [
    'Plus de trois fois les modules (36 contre 10+) avec une interface moderne de qualit\u00e9 entreprise',
    'Module complet de restauration avec POS, service en chambre et gestion de cuisine inclus',
    'Gestion avanc\u00e9e des revenus avec tarification dynamique, pr\u00e9vision et simulateurs hypoth\u00e9tiques',
    'Interface luxe sombre moderne con\u00e7ue pour 2026 contre interface fonctionnelle mais dat\u00e9e de WebRezPro',
    'Gestion compl\u00e8te de cha\u00eene multi-\u00e9tablissements avec analyses centralis\u00e9es et distribution tarifaire',
    'Port\u00e9e mondiale dans plus de 40 pays contre la focalisation nord-am\u00e9ricaine de WebRezPro',
    'Programme de fid\u00e9lit\u00e9, CRM client et communications automatis\u00e9es pour les r\u00e9servations r\u00e9p\u00e9t\u00e9es',
    'Int\u00e9gration et migration de donn\u00e9es gratuites avec support d\u00e9di\u00e9 24h/24 7j/7',
  ],
  verdict: {
    title: 'Notre verdict',
    summary: 'WebRezPro est un PMS canadien fiable avec de solides fonctionnalit\u00e9s comptables pour les petits et moyens h\u00f4tels nord-am\u00e9ricains. Cependant, son interface dat\u00e9e, son ensemble de fonctionnalit\u00e9s limit\u00e9 et son manque de restauration, d\'outils de revenus avanc\u00e9s et d\'\u00e9volutivit\u00e9 entreprise en font un choix moins comp\u00e9titif en 2026. HotelStack.io offre une plateforme moderne et compl\u00e8te qui \u00e9gale WebRezPro en comptabilit\u00e9 tout en ajoutant plus de 22 modules suppl\u00e9mentaires, une interface de classe mondiale et des capacit\u00e9s mondiales.',
    bestFor: [
      'H\u00f4tels souhaitant une interface moderne sans sacrifier la profondeur comptable',
      '\u00c9tablissements n\u00e9cessitant restauration, POS et gestion de cuisine au-del\u00e0 du PMS basique',
      'H\u00f4tels recherchant une gestion avanc\u00e9e des revenus et des outils de tarification dynamique',
      '\u00c9tablissements s\'\u00e9tendant \u00e0 l\'international au-del\u00e0 de l\'Am\u00e9rique du Nord',
      'Groupes h\u00f4teliers en croissance n\u00e9cessitant la gestion compl\u00e8te de cha\u00eene multi-\u00e9tablissements',
    ],
  },
  faqItems: [
    { question: 'Puis-je migrer de WebRezPro vers HotelStack.io ?', answer: 'Oui. Notre \u00e9quipe de migration g\u00e8re le transfert complet des donn\u00e9es depuis WebRezPro, y compris les profils clients, l\'historique des r\u00e9servations, les plans tarifaires, les donn\u00e9es comptables et les configurations de chambres. La migration est gratuite et g\u00e9n\u00e9ralement termin\u00e9e en 48 heures sans interruption.' },
    { question: 'HotelStack.io \u00e9gale-t-il les capacit\u00e9s comptables de WebRezPro ?', answer: 'Oui. HotelStack.io inclut la comptabilit\u00e9 int\u00e9gr\u00e9e, les comptes de r\u00e9sultat, les comptes clients, la facturation personnalis\u00e9e et la facturation multidevise. De plus, il ajoute plus de 22 modules suppl\u00e9mentaires incluant restauration, gestion des revenus, CRM client et gestion multi-\u00e9tablissements que WebRezPro ne propose pas.' },
    { question: 'Comment l\'interface de HotelStack.io se compare-t-elle \u00e0 WebRezPro ?', answer: 'HotelStack.io pr\u00e9sente une interface luxe sombre moderne construite avec les derni\u00e8res technologies web, offrant un design r\u00e9actif sur tous les appareils. WebRezPro a une interface fonctionnelle mais dat\u00e9e con\u00e7ue pour une \u00e8re ant\u00e9rieure des applications web.' },
    { question: 'HotelStack.io convient-il aux \u00e9tablissements canadiens utilisant actuellement WebRezPro ?', answer: 'Absolument. HotelStack.io prend en charge la facturation multidevise y compris le CAD, la conformit\u00e9 fiscale canadienne (TPS/TVH/TVP) et se connecte \u00e0 tous les principaux OTA nord-am\u00e9ricains. De nombreux \u00e9tablissements canadiens changent pour les modules suppl\u00e9mentaires et l\'exp\u00e9rience moderne.' },
  ],
};


export const COMPARISON_FR_P3B: Record<string, ComparisonConfig> = {
  'hotelstack-vs-innroad': INNROAD_FR,
  'hotelstack-vs-webrezpro': WEBREZPRO_FR,
};
